import { ErrorPageContent } from '../content.types';
import { dataFor } from '../data';
import { useLanguage } from './use-content';

export interface UseErrorPageContentResult {
  content?: ErrorPageContent;
  isLoading: boolean;
}

export function useErrorPageContent(id?: string): UseErrorPageContentResult {
  const language = useLanguage();
  const pages = dataFor('errorPages', language);
  const content = id ? pages[id] : undefined;
  return { content, isLoading: false };
}
